import React, { Component } from 'react'
import { Alert, Spin } from 'antd';
const contentStyle = {
  padding: 50,
  background: 'rgba(0, 0, 0, 0.05)',
  borderRadius: 4,
};
const content = <div style={contentStyle} />;
export default class Loaddingsubmit extends Component {
    render() {
        return (
          
            <div  role="status">
             {/* <p className='text-center'><span class="visually-hidden">Loading...</span></p>  */}

             <Spin description="Loading...">
      <Alert
        title="Loading...data"
        description="กำลังส่งข้อมูล กรุณารอสักครู่..."
        type="info"
      />
    </Spin>
            </div>

            
          
        )
    }
}
